import baseConfig from '../config.js';
import basicFormHelper from '../basic.form.helper.js';
import {regular} from '../validate.js.js';

import moment from 'moment';

//注明：如果列表中需要有编码，配置initCodeRules，则会自动加载XXDesc,XXCodeItems(XX表示数据项的属性名)
const classColumns: any = [
    {
        dataIndex: 'serialNumber',
        title: '序号',
        width: '70px',
        scopedSlots: {
            customRender: 'serialNumber'
        }
    },
    {
        dataIndex: 'name',
        width: '170px',
        slots: {title: 'name'}
    },
    {
        dataIndex: 'periodValue',
        title: '学段',
        width: '60px'
    },
    {
        dataIndex: 'gradeValue',
        title: '年级',
        width: '80px'
    },
    {
        dataIndex: 'attribute',
        title: '班级属性',
        width: '90px',
        customRender: (text: Number) => {
            if (text === 1) return '行政班';
            if (text === 2) return '兴趣班';
        }
    },
    {
        dataIndex: 'classCoursIds',
        title: '关联课程',
        width: '90px',
        scopedSlots: {
            customRender: 'classCourse'
        }
        // customRender: (text: any) => {
        //     if (text.length > 0) {
        //         return text.length;
        //     } else {
        //         return '暂无';
        //     }
        // }
    },
    {
        dataIndex: 'appClassCourseIds',
        slots: {title: 'additionCourse'},
        width: '110px',
        scopedSlots: {
            customRender: 'appClassCourseIds'
        }
        // customRender: (text: any) => {
        //     if (text.length > 0) {
        //         return text.length;
        //     } else {
        //         return '暂无';
        //     }
        // }
    },
    {
        dataIndex: 'teacherList',
        title: '关联教师',
        width: '90px',
        scopedSlots: {
            customRender: 'classTeacher'
        }
        // customRender: (text: any) => {
        //     if (text.length == 0) {
        //         return '暂无';
        //     }
        //     return text.length;
        // }
    },
    {
        dataIndex: 'studentCount',
        title: '关联学生',
        width: '90px',
        scopedSlots: {
            customRender: ''
        },
        customRender: (text: any) => {
            if (text == 0) {
                return '暂无';
            }
            return text;
        }
    },
    {
        dataIndex: 'createdAt',
        title: '创建时间',
        width: '170px',
        slots: {title: ''},
        customRender: (text: any) => {
            return moment(text)
                .utcOffset(8)
                .format('YYYY/MM/DD HH:mm:ss');
        }
    },
    {
        title: '操作',
        width: '280px',
        dataIndex: 'operation',
        scopedSlots: {customRender: 'operation'}
    }
];

const studentColumns: any = [
    {
        dataIndex: 'serialNumber',
        title: '序号',
        width: '60px',
        scopedSlots: {
            customRender: 'serialNumber'
        }
    },
    {
        dataIndex: 'nickname',
        title: '姓名',
        width: '120px',
        ellipsis: true,
        scopedSlots: {
            customRender: 'nickname'
        }
    },
    {
        title: '性别',
        dataIndex: 'sex',
        width: '60px',
        customRender: (text: Number) => {
            if (text === 0) return '女';
            if (text === 1) return '男';
            return '未知';
        }
    },
    {
        dataIndex: 'username',
        title: '账号',
        width: '230px',
        scopedSlots: {
            customRender: 'studentAccount'
        }
    },
    {
        dataIndex: 'password',
        title: '密码',
        width: '125px',
        scopedSlots: {
            customRender: 'pwd'
        }
    },
    {
        dataIndex: '',
        title: '账号状态',
        ellipsis: 'true',
        width: '120px',
        scopedSlots: {customRender: 'state'}
    },
    {
        title: '账号有效期',
        scopedSlots: {
            customRender: 'usefulLife'
        },
        width: '190px',
        ellipsis: true
    },
    {
        dataIndex: 'createdAt',
        title: '创建时间',
        width: '170px',
        scopedSlots: {
            customRender: 'createdAt'
        }
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: '230px',
        scopedSlots: {customRender: 'operation'}
    }
];

const authorizeColumns: any = [
    {
        dataIndex: 'serialNumber',
        title: '序号',
        width: '80px',
        scopedSlots: {
            customRender: 'serialNumber'
        }
    },
    {
        title: '关联课程',
        dataIndex: 'courseName'
    },
    {
        title: '关联教师',
        dataIndex: 'teachers[0].nickname',
        width: '320px',
        scopedSlots: {
            customRender: 'teacher'
        }
    },
    {
        title: '关联时间',
        dataIndex: 'date',
        customRender: (text: any) => {
            return moment(text)
                .utcOffset(8)
                .format('YYYY/MM/DD HH:mm:ss');
        }
    },
    {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: {
            customRender: 'operation'
        }
    }
];

const courseTeacherColumns: any = [
    {
        title: '课程名称',
        dataIndex: 'courseName',
        width: '50%'
    },
    {
        dataIndex: '',
        title: '关联教师',
        width: '50%',
        scopedSlots: {
            customRender: 'teacher'
        }
    }
];

const studentDColumns: any = [
    {
        dataIndex: 'grade',
        title: '年级'
    },
    {
        dataIndex: 'classname',
        title: '班级'
    },
    {
        dataIndex: 'teachername',
        title: '授课教师'
    },
    {
        dataIndex: 'mobile',
        title: '手机号'
    },
    {
        dataIndex: 'nickname',
        title: '学生'
    },
    {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: {customRender: 'operation'}
    }
];
const errorColunms: any = [
    {
        dataIndex: 'serialNumber',
        title: '序号',
        width: '80px',
        scopedSlots: {
            customRender: 'serialNumber'
        }
    },
    {
        dataIndex: 'nickname',
        title: '学生姓名',
        width: '120px',
        scopedSlots: {
            customRender: 'nickname'
        }
    },
    {
        dataIndex: 'platformSameName',
        title: '平台学生姓名',
        width: '120px',
        scopedSlots: {
            customRender: 'platformSameName'
        }
    },
    {
        dataIndex: 'password',
        title: '登录密码',
        width: '17%',
        scopedSlots: {
            customRender: 'password'
        }
    },
    {
        dataIndex: 'sex',
        title: '性别',
        width: '80px',
        scopedSlots: {
            customRender: 'sex'
        }
    },
    {
        title: '错误提示',
        width: '40%',
        scopedSlots: {
            customRender: 'error'
        }
    }
];

const formClass: any = {
    schoolId: '',
    name: '',
    period: undefined,
    grade: undefined,
    attribute: undefined,
    _id: ''
};

const formRulesClass: any = {
    grade: [
        {
            required: true,
            message: '请选择年级',
            trigger: 'change'
        }
    ],
    name: [
        {
            required: true,
            message: '请输入班级名称',
            trigger: 'change'
        }
        // { validator: this.checkSpecial, trigger: 'blur' }
    ],
    period: [
        {
            required: true,
            message: '请选择学段',
            trigger: 'change'
        }
    ],
    attribute: [
        {
            required: true,
            message: '请选择属性',
            trigger: 'change'
        }
    ]
};

/**
 * 其实就是把本页面定义的form数据,重新copy一份数据出来
 */
const copyNewForm = function() {
    let jsonStr = JSON.stringify(formClass);
    let newForm = JSON.parse(jsonStr);
    return newForm;
};

/**
 * 把本地页面data中定义的form转换接口所需的数据格式
 * @param {Object} pageForm
 */
const convertDbForm = function(pageForm: any) {
    let dbForm = {
        ...{},
        ...pageForm
    };

    // let codeStr = dbForm.code + '';
    // dbForm.code = codeStr;

    return dbForm;
};

/**
 * 把通过查询返回的数据格式塞入到页面data的from属性中
 * @param {Object} dbFrom
 * @param {Object} contextForm
 */
const dbToForm = function(dbFrom: any, contextForm: any) {
    //赋值
    let newForm: any = {};

    for (let p in dbFrom) {
        newForm[p] = dbFrom[p];
    }
    return newForm;
};

export default {
    classColumns,
    studentColumns,
    authorizeColumns,
    courseTeacherColumns,

    studentDColumns,
    errorColunms,

    formClass,

    formRulesClass,

    copyNewForm: basicFormHelper.copyNewForm,

    convertDbForm,
    dbToForm,

    allowUploadTypes: basicFormHelper.allowUploadTypes
};
